import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import basePath from 'utils/basePath';
import Load from 'components/Load';
import { isCordova } from 'utils/platform';
import { Route } from 'react-router-dom';

const AsyncHostPage = Load(() => import(
  /* webpackChunkName: "host-page" */
  './components/HostPage'
), {}, true);

const AsyncContactHostSuccess = Load(() => import(/* webpackChunkName: "contact-host-form" */'modules/host/containers/ContactHostSuccessContainer'), {}, true);
const AsyncContactHostSendingModal = Load(() => import(/* webpackChunkName: "contact-host-form" */'modules/host/containers/ContactHostSendingModalContainer'), {}, true);
const AsyncContactHostForm = Load(() => import(/* webpackChunkName: "contact-host-form" */'modules/host/containers/ContactFormContainer'), {}, true);
const AsyncExperiencesModal = Load(() => import(/* webpackChunkName: "experiences-modal" */ './components/HostExperiences/modals/ExperienceModal'), {}, true);

const HostRoute = [(
  <NavigationableLayout
    key="contact-form-success"
    path={`${basePath}/host/:pretty_url/contact/:form/success`}
    component={AsyncContactHostSuccess}
    hideFooter
  />
), (
  <Route key="contact-form-sending" path={`${basePath}/host/:pretty_url/contact/:form/sending`} component={AsyncContactHostSendingModal} />
), (
  <NavigationableLayout key="contact-form" path={`${basePath}/host/:pretty_url/contact/:form`} component={AsyncContactHostForm} hideFooter />
), (
  <Route key="experiences-modal" path={`${basePath}/host/:pretty_url/experiences`} component={AsyncExperiencesModal} />
), (
  <NavigationableLayout
    key="host"
    path={`${basePath}/host/:pretty_url`}
    component={AsyncHostPage}
    noNavbar={isCordova()}
  />
),
];

export default HostRoute;
